import BaseService from './BaseService';
import { AnimalGroupAnalyticsDetailedResult, AnimalGroupAnalyticsResult } from '../models/vitality-tracker';

export class VitalityTrackerService extends BaseService {
  getGroupAnalytics = async (
    locationIds: string[],
    from: Date,
    to: Date,
    isAvgTime: boolean
  ): Promise<AnimalGroupAnalyticsResult> => {
    const query = JSON.stringify({ locationIds, from, to, isAvgTime });
    const result = await this.Fetch(`/vitality/analytics`, 'POST', query);
    return this.FromResult<AnimalGroupAnalyticsResult>(result);
  };

  getDetailedGroupAnalytics = async (
    animalIds: string[],
    from: Date,
    to: Date
  ): Promise<AnimalGroupAnalyticsDetailedResult> => {
    const query = JSON.stringify({ animalIds, from: from.toISOString(), to: to.toISOString() });
    const result = await this.Fetch(`/vitality/analytics/detailed`, 'POST', query);
    return this.FromResult<AnimalGroupAnalyticsDetailedResult>(result);
  };
}
